<template>
  <v-container fluid>
    <div v-if="isCliente == 0">
      <section class="content-header">
        <v-toolbar dark dense color="#96298A">
          <v-toolbar-title>Actualización Masiva de Estatus</v-toolbar-title>
        </v-toolbar>
      </section>
        <v-card elevation="24" outlined>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12" md="3">
                  <v-card height="100%" elevation="24" outlined shaped>
                    <v-card-title>Seleccionar guias a Agregar</v-card-title>
                    <v-card-text>
                      <!--v-autocomplete
                        v-model="guiaAdd"
                        :items="guiasAdd"
                        :search-input.sync="search"
                        item-value="id"
                        item-text="guia_interna"
                        clearable
                        return-object
                        cache-items
                        hide-no-data
                        hide-details
                        label="Guía"
                      >
                      </v-autocomplete-->
                      <v-textarea
                      v-model="searchGuiaAdd"
                      ref="searchGuiaAdd"
                      clearable
                      label="Ingrese Guias"
                      append-icon="mdi-earth"
                      @keyup.enter="addGuiaList()"
                      ></v-textarea>
                    </v-card-text>
                    <!--v-card-actions>
                      <v-spacer></v-spacer
                      ><v-btn
                        dark
                        small
                        color="light-blue darken-4"
                        @click="addGuiaList()"
                        outlined
                        >Agregar <v-icon>mdi-arrow-right-box</v-icon></v-btn
                      >
                    </v-card-actions-->
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-card height="100%" elevation="24" outlined shaped>
                    <v-card-title>Guias</v-card-title>
                    <v-card-text>
                      <v-data-table
                        v-model="selectedGuiasRS"
                        :headers="headersGR"
                        :items="guiasLst"
                        item-key="guia_interna"
                        class="elevation-1"
                      >
                        <template v-slot:item.acciones="{ item }">
                          <v-tooltip bottom color="#96298A">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                color="red"
                                @click="deletegrs(item)"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </template>
                            <span>Eliminar</span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="5">
                    <v-card height="100%" elevation="24" outlined shaped>
                        <v-card-title>Estatus</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-combobox
                                        v-model="estatus"
                                        :items="lstEstatus"
                                        label="Estatus"
                                        required
                                        :rules="[reglas.requeridoTxt]"
                                        item-value="id"
                                        item-text="descripcion"
                                        :disabled="disabled"
                                        return-object
                                    ></v-combobox>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                    type="date"
                                    v-model="fecha"
                                    label="Fecha"
                                    required
                                    :rules="[reglas.requeridoTxt]"
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                    type="time"
                                    v-model="hora"
                                    label="Hora"
                                    required
                                    :rules="[reglas.requeridoTxt]"
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-textarea
                                        label="Comentarios"
                                        v-model="comentarios"
                                        append-icon="mdi-file-edit"
                                        ></v-textarea>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" @click="saveItem()" outlined>
              Guardar
              <v-icon dark>mdi-content-save</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
    </div>
    <div v-else>
      <h1>Usted no tiene permisos para ver esta sección</h1>
    </div>
  </v-container>
</template>
<script>
import apicon from "../plugins/apicon";
import Waiting from "../components/Waiting.vue";
export default {
  components: {
    Waiting,
  },
  created: function () {},
  data() {
    return {
      search: null,
      overlay: false,
      fullScreen: true,
      searcher: "",
      valid: true,
      guiasAdd: [],
      guiaAdd: null,
      searchGuiaAdd: null,
      guiasLst: [],
      selectedGuiasRS: [],
      headersGR: [
        { text: "Guia", value: "guia_interna" },
        { text: "Acciones", value: "acciones", align: "end", sortable: false },
      ],
      /*Variables*/
      fecha: null,
      hora: null,
      comentarios: null,
      /*Variables*/
      isCliente: 1,
      lstEstatus: [],
      estatus: null,
    };
  },
  watch: {
    search(val) {
      val && val !== this.guiaAdd && this.fillGuiasAdd(val);
    },
  },
  methods: {
    fillGuiasAdd: async function (v) {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "guiasrs?search=" + this.search)
        .then((result) => {
          this.guiasAdd = result;
        });
    },
    //Agregar guia a lista
    addGuiaList:async function () {
      let guias = this.searchGuiaAdd.split(',');
      if(guias.length == 1){//es porque no estan separadas por coma y probablemente por espacio
        guias = this.searchGuiaAdd.split('\n').filter(item => item.trim() !== '');
      }

      guias.forEach(async guia => {
        if(guia != null && guia != ''){
          let flag = true //await this.verificarGuiaExiste(this.searchGuiaAdd);
          if(flag){
            var guiaA = {
              id: 0,
              id_guia: null,
              guia_interna: guia,
            };
            this.guiasLst.push(guiaA);
            this.guiaAdd = null;
            this.searchGuiaAdd = null;
            this.$refs.searchGuiaAdd.focus();
          }else{
            console.log("Guía No Existe");
          }
        }
      });
    },
    deletegrs: function (item) {
      var self = this;
      this.$swal(this.dswalEliminar).then((resultdlg) => {
        if (resultdlg.value) {
            self.guiasLst.splice(
              self.guiasLst.findIndex(
                (g) => g.guia_interna === item.guia_interna
              ),
              1
            );
        }
      });
    },
    verificarGuiaExiste: async function (guia) {
      let flag = false;
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "verificarguiarsexiste/" + guia)
        .then((result) => {
          if (result.status) {
            flag = true;
            this.guiaAdd = result.guia;
          }
        });
      return flag;
    },
    //Guardar o Actualizar
    saveItem: async function () {
      if (this.$refs.form.validate()) {
        if(this.guiasLst.length > 0){
          let lstGuias = JSON.stringify(this.guiasLst);
          //Guardar
          this.overlay = true;
          await apicon
            .saveDataApi(apicon.getApiBaseUrl() + "actualizarestatusguias", {
              id_estatus : this.estatus.id,
              fecha: this.fecha,
              hora: this.hora,
              comentarios : this.comentarios,
              guias : lstGuias
            })
            .then((result) => {
              console.log(result);
            });
          this.overlay = false;
          this.$swal("Completado");
          this.limpiar();
        }else{
          this.$swal("Por favor ingrese las guias a las cuales actualizar Estatus");
        }
      }
    },
    limpiar: function(){
      this.guiaAdd = null;
      this.guiasLst = [];
      this.estatus = null;
      this.fecha = null;
      this.hora = null;
      this.comentarios = null;
    },
    //Eliminar
    deleteItem: function (item) {
      var self = this;
      this.$swal(this.dswalEliminar).then((resultdlg) => {
        if (resultdlg.value) {
          var url = apicon.getApiBaseUrl() + "runsheet/" + item.id;
          apicon.deleteDataApi(url).then((result) => {
            this.$swal(result.message);
          });
        }
      });
    },
    getLstEstatus: function () {
      apicon
        .getDataApi(apicon.getApiBaseUrl() + 'estatusall')
        .then((result) => {
          this.lstEstatus = result
        })
    },
  },
  mounted() {
    apicon.setAuthHeaders();
    this.getLstEstatus();
    this.isCliente = localStorage.getItem("cliente");
  },
};
</script>
